// extracted by mini-css-extract-plugin
export default {"root":"nqHx5-2J","body":"_3R0KQWFO","text":"_3emDXLxf"};